import { styled } from '@mui/material/styles';
// import { COLOR } from '@src/styles/color';

const StyledVerifyVoice = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px;
  box-sizing: border-box;
`;

const StyledTerms = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 860px;
  margin: 0 auto;
  .cycle-blur-image {
    width: 248px;
    height: 248px;
  }
  .terms-content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 8px;
  }
`;

export { StyledVerifyVoice, StyledTerms };
